import React from 'react'

const PaytmSDK = ({url,txnToken,orderId, paytmMID}) => {
  return (
    <div>
          <form method="post" action={url && url} name="paytm">
            <table border="1">
              <tbody>
                <input type="hidden" name="mid" value={paytmMID && paytmMID} />
                <input type="hidden" name="orderId" value={orderId && orderId} />
                <input type="hidden" name="txnToken" value={txnToken && txnToken} />
              </tbody>
            </table>
          </form>
    </div>
  )
}

export default PaytmSDK